import { getRgObjectsOfType as g, RG_TYPE as f } from "@project-rouge/rg-core";
import { getPolygonCornerCount as a } from "../../../geometry-utils/core/index15.js";
const u = (t, r) => {
  let o = 0;
  const n = g(t, f.Building);
  for (const e of n)
    o += d(e, r);
  return o;
};
function d(t, r) {
  const o = t.data.levels.filter((e) => e.levelIndex === r);
  let n = 0;
  for (const e of o) {
    const i = t.children.find((l) => l.type === f.Facade && l.data.levelId === e.uuid);
    if (!!i) {
      if (e.geaPolygon)
        n += a(e.geaPolygon).internal * i.size[1];
      else if (e.roofFacadePerimeter)
        for (const l of e.roofFacadePerimeter)
          n += a(l).internal * i.size[1];
    }
  }
  return n;
}
export {
  u as getLevelFacadeInternalCornerLength
};
//# sourceMappingURL=index17.js.map
